import React, { ChangeEvent, InputHTMLAttributes, useCallback } from "react";

import { FieldProps } from "formik";
import { SpaceProps } from "styled-system";
import { SquareCheckbox } from "../SquareCheckbox";
import { SquareCheckboxProps } from "../SquareCheckbox/SquareCheckbox";

interface Props {
  onCheckedChange?: (checked: boolean) => void;
  value: boolean | string;
  checked: boolean;
}

export const FormikSquareCheckbox: React.FC<
  Props &
    FieldProps &
    SquareCheckboxProps &
    SpaceProps &
    InputHTMLAttributes<HTMLInputElement>
> = ({ field, form, onCheckedChange, checked, value, ...props }) => {
  const updateFormik = useCallback(
    (checked: boolean): void => {
      form.setFieldValue(field.name, checked ? value : undefined);
      if (onCheckedChange) {
        onCheckedChange(checked);
      }
    },
    [field, form, onCheckedChange, value],
  );

  const handleOnKeyDown = (event: React.KeyboardEvent<HTMLLabelElement>) => {
    // Detect spacebar keypress
    if (event.key === " ") {
      updateFormik(!checked);
    }
  };

  const handleOnChange = (event: ChangeEvent<HTMLInputElement>) => {
    updateFormik(event.target.checked);
  };

  return (
    <SquareCheckbox
      {...field}
      {...props}
      onKeyDown={handleOnKeyDown}
      onChange={handleOnChange}
      checked={checked}
    />
  );
};
